/**
 * @typedef {Object} Region
 * @property {string} id
 * @property {string} shortName
 * @property {string} longName
 * @property {string} userRegionCookieValue - the value stored in the {@link USER_REGION} cookie
 */

/**
 * @type {Region}
 */
export const NSW = {
  id: 'NSW',
  userRegionCookieValue: 'nsw',
  shortName: 'NSW',
  longName: 'New South Wales',
  defaultPostcode: '2000',
};

/**
 * @type {Region}
 */
export const QLD = {
  id: 'QLD',
  userRegionCookieValue: 'qld',
  shortName: 'QLD',
  longName: 'Queensland',
  defaultPostcode: '4000',
};

/**
 * @type {Region}
 */
export const VIC = {
  id: 'VIC',
  userRegionCookieValue: 'vic',
  shortName: 'VIC',
  longName: 'Victoria',
  defaultPostcode: '3000',
};

/**
 * @type {Region}
 */
export const TAS = {
  id: 'TAS',
  userRegionCookieValue: 'tas',
  shortName: 'TAS',
  longName: 'Tasmania',
  defaultPostcode: '7000',
};

/**
 * @type {Region}
 */
export const WA = {
  id: 'WA',
  userRegionCookieValue: 'wa',
  shortName: 'WA',
  longName: 'Western Australia',
  defaultPostcode: '6000',
};

/**
 * @type {Region}
 */
export const SA = {
  id: 'SA',
  userRegionCookieValue: 'sa',
  shortName: 'SA',
  longName: 'South Australia',
  defaultPostcode: '5000',
};

/**
 * @type {Region}
 */
export const ACT = {
  id: 'ACT',
  userRegionCookieValue: 'act',
  shortName: 'ACT',
  longName: 'Australian Capital Territory',
  defaultPostcode: '2600',
};

/**
 * @type {Region}
 */
export const NT = {
  id: 'NT',
  userRegionCookieValue: 'nt',
  shortName: 'NT',
  longName: 'Northern Territory',
  defaultPostcode: '0800',
};
